import styled from 'styled-components'
import { theme } from '@notino/react-styleguide'

import { NotinoTitleExtraExtraLarge, NotinoTitleMedium } from '../../styles/helpers'

export const NotFoundTitle = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
`

export const NotFoundCode = styled.span`
	${NotinoTitleExtraExtraLarge};
	color: ${theme.color.text.primary};
`

export const NotFoundMessage = styled.span`
	${NotinoTitleMedium};
	color: ${theme.color.text.primary};
`
